import { render } from "./AnnouncementService.vue?vue&type=template&id=fe26023c"
import script from "./AnnouncementService.vue?vue&type=script&lang=js"
export * from "./AnnouncementService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__